import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceHubMerchCards = () => {
  const productsConfig = {
    PROFESSIONAL: {
      apiName: Products.COMMERCE_HUB_PROFESSIONAL,
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.commerce.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: Products.COMMERCE_HUB_ENTERPRISE,
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.commerce.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};